package org.multiplatform.kotfolio.pages.koin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("shared")
@Composable
fun KoinSharedPage() {
    BlogLayout(
        PageProperties(
            "Koin",
            ""
        ),
        BlogProperties("Koin", "Shared")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Koin Shared ViewModel Old Way",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //https://github.com/Uwi0/Oakane

                    //iosApp
                    @main
                    struct iOSApp: App {

                        @ObservedObject var navigation = AppNavigation()

                        init () {
                            Koin.start()
                        }

                        var body: some Scene {
                            WindowGroup {
                                ContentView()
                                .environmentObject(navigation)
                            }
                        }
                    }

                    //Koin.swift
                    import Foundation
                    import Shared

                    final class Koin {
                        private var core: Koin_coreKoin?

                        static let instance: Koin = Koin()

                        static func start() {
                            if instance.core == nil {
                                let app = KoinIos.shared.initialize()
                                instance.core = app.koin
                            }
                            if instance.core == nil {
                                fatalError("Koin is not initialized")
                            }
                        }

                        private init() {

                        }

                        func get<T: AnyObject>() -> T {
                            guard let core = core else {
                              fatalError("You should call `start()` before using \(#function)")
                            }

                            guard let result = core.get(objCClass: T.self) as? T else {
                              fatalError("Koin can't provide an instance of type: \(T.self)")
                            }

                            return result
                          }
                    }

                    //iosMain
                    //KoinIos.kt
                    import kotlinx.cinterop.ObjCClass
                    import kotlinx.cinterop.getOriginalKotlinClass
                    import org.koin.core.Koin
                    import org.koin.core.KoinApplication
                    import org.koin.core.module.Module
                    import org.koin.core.parameter.parametersOf
                    import org.koin.core.qualifier.Qualifier
                    import org.koin.dsl.module

                    object KoinIos {
                        fun initialize(): KoinApplication = initKoin(
                            appModule = module {

                            }
                        )
                    }

                    @OptIn(kotlinx.cinterop.BetaInteropApi::class)
                    fun Koin.get(objCClass: ObjCClass): Any {
                        val kClass = getOriginalKotlinClass(objCClass)!!
                        return get(kClass)
                    }

                    @OptIn(kotlinx.cinterop.BetaInteropApi::class)
                    fun Koin.get(objCClass: ObjCClass, qualifier: Qualifier?, parameter: Any): Any {
                        val kClazz = getOriginalKotlinClass(objCClass)!!
                        return get(kClazz, qualifier) { parametersOf(parameter) }
                    }

                    actual val platformModule: Module = module {
                        single { MySqlDriverFactory().createDriver() }
                    }
                    """.trimIndent()
            )

            //https://github.com/Rahul93102/Book-App-CMP
            KotlinCode(
                code = """
                    //common
                    fun initKoin(config: KoinAppDeclaration? = null) {
                        startKoin {
                            config?.invoke(this)
                            modules(sharedModule, platformModule)
                        }
                    }
                    
                    expect val platformModule: Module
                    
                    @Composable
                    fun App() {
                        MaterialTheme {}
                    }
                    
                    //iOS
                    actual val platformModule: Module
                        get() = module {
                            single<HttpClientEngine> { Darwin.create() }
                            single { DatabaseFactory() }
                    }
                    
                    fun MainViewController() = ComposeUIViewController(
                        configure = {
                            initKoin()
                        }
                    ) { App() }
                    
                    //android
                    actual val platformModule: Module
                        get() = module {
                            single<HttpClientEngine> { OkHttp.create() }
                            single { DatabaseFactory(androidApplication()) }
                    }
                    
                    class BookApplication: Application() {
                        override fun onCreate() {
                            super.onCreate()
                            initKoin {
                                androidContext(this@BookApplication)
                            }
                        }
                    }
                    
                    class MainActivity : ComponentActivity() {
                        override fun onCreate(savedInstanceState: Bundle?) {
                            super.onCreate(savedInstanceState)

                            setContent {
                                App()
                            }
                        }
                    }
                    
                    //ContentView.swift
                    import UIKit
                    import SwiftUI
                    import ComposeApp

                    struct ComposeView: UIViewControllerRepresentable {
                        func makeUIViewController(context: Context) -> UIViewController {
                            MainViewControllerKt.MainViewController()
                        }

                        func updateUIViewController(_ uiViewController: UIViewController, context: Context) {}
                    }

                    struct ContentView: View {
                        var body: some View {
                            ComposeView()
                                    .ignoresSafeArea(.keyboard)
                                    .ignoresSafeArea(.container) // Compose has own keyboard handler
                        }
                    }
                    
                    //iOSApp.swift
                    import SwiftUI

                    @main
                    struct iOSApp: App {
                        var body: some Scene {
                            WindowGroup {
                                ContentView()
                            }
                        }
                    }
                    """.trimIndent()
            )

            //https://github.com/binishmanandhar23/BreastCancerCare.git
            KotlinCode(
                code = """
                    fun initKoin(appDeclaration: KoinAppDeclaration = {}) {
                        startKoin {
                            appDeclaration()
                            modules(
                                commonModule() + platformModule()
                            )
                        }
                    }
                    
                    fun commonModule(): Module = module { }
                    
                    expect fun platformModule(): Module
                    
                    //android
                    class MainApplication: Application() {
                        override fun onCreate() {
                            super.onCreate()
                            initKoin(
                                appDeclaration = { androidContext(this@MainApplication) },
                            )
                        }
                    }
                    
                    //iOS
                    //Koin.kt
                    fun initKoinIos() = initKoin(appDeclaration = {})
                    
                    fun MainViewController() = ComposeUIViewController { App() }
                    
                    //iOSApp.swift
                    @main
                    struct iOSApp: App {
                        init() {
                            KoinKt.doInitKoinIos()
                        }
                    }
                    
                    //ContentView.swift
                    struct ComposeView: UIViewControllerRepresentable {
                        func makeUIViewController(context: Context) -> UIViewController {
                            MainViewControllerKt.MainViewController()
                        }

                        func updateUIViewController(_ uiViewController: UIViewController, context: Context) {}
                    }

                    struct ContentView: View {
                        var body: some View {
                            ComposeView()
                                .ignoresSafeArea()
                        }
                    }
                    """.trimIndent()
            )

            //https://github.com/delacrixmorgan/kingscup-kmp.git
            KotlinCode(
                code = """
                    fun initKoin(appDeclaration: KoinAppDeclaration = {}) = 
                        startKoin {
                            appDeclaration()
                            modules(
                                platformModule(),
                                viewModelModule(),
                                useCaseModule(),
                                repositoryModule(),
                        )
                    }
                    
                    class PreferencesRepository(
                        private val dataStore: DataStore<Preferences>
                    ) : KoinComponent {
                    
                    }
                    
                    @Composable
                    fun AppTheme(
                        skin: SkinPreference = SkinPreference.Default,
                        theme: ThemePreference = ThemePreference.Default,
                        isSystemDark: Boolean = isSystemInDarkTheme(),
                        content: @Composable () -> Unit
                    ) {
                        MaterialTheme(
                            colorScheme = skin.getColorScheme(theme, isSystemDark),
                            typography = AppTypography,
                            shapes = AppShapes,
                            content = content
                        )
                    }
                    
                    @Composable
                    fun App(modifier: Modifier = Modifier) {
                        AppNavHost()
                    }
                    
                    //android
                    class App : Application() {
                        override fun onCreate() {
                            super.onCreate()
                            initKoin {
                                androidContext(this@App)
                                androidLogger()
                            }
                        }
                    }
                    
                    class MainActivity : ComponentActivity(), KoinComponent {
                    
                        private val preferencesRepository: PreferencesRepository by inject()

                            override fun onCreate(savedInstanceState: Bundle?) {
                                super.onCreate(savedInstanceState)
                                enableEdgeToEdge()
                            
                                setContent {
                                    AppTheme(skin.value, theme.value) {
                                        Scaffold {
                                            val insetModifier = Modifier
                                                .windowInsetsPadding(WindowInsets.displayCutout)
                                                .consumeWindowInsets(it)
                                            App(insetModifier)
                                        }
                                }
                            }
                        }
                    }
                    
                    //iOS
                    
                    //koin.kt
                    fun initKoin() {
                        startKoin {
                            modules(
                                platformModule(),
                                viewModelModule(),
                                useCaseModule(),
                                repositoryModule(),
                            )
                        }
                    }
                    
                    object KoinHelper : KoinComponent
                   
                    //MainViewController.kt
                    fun MainViewController() = ComposeUIViewController {
                        val preferencesRepository = KoinHelper.get<PreferencesRepository>()
                        
                         AppTheme(skin.value, theme.value) {
                            Scaffold {
                                val insetModifier = Modifier
                                    .windowInsetsPadding(WindowInsets.displayCutout)
                                    .consumeWindowInsets(it)
                                App(insetModifier)
                            }
                        }
                    }
                    
                    //iOSApp.swift
                    import SwiftUI
                    import ComposeApp

                    @main
                    struct iOSApp: App {

                        init() {
                            KoinKt.doInitKoin()
                        }

                        var body: some Scene {
                            WindowGroup {
                                ContentView()
                            }
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    class KoinInitializer : Initializer<Unit> {
                        override fun create(context: Context) {
                            // startKoin
                        }
                        override fun dependencies(): List<Class<out Initializer<*>>>
                        {
                            return emptyList()
                        }
                    }

                    //Kotlin Multiplatform
                    @OptIn(ExperimentalSettingsApi::class)
                    val sharedModule = module {

                    }

                    expect val targetModule: Module

                    fun initializeKoin(
                        config: (KoinApplication.() -> Unit)? = null
                    ) {
                        startKoin {
                            config?.invoke(this)
                            modules(sharedModule, targetModule)
                        }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    fun initKoin() {
                        startKoin {
                            modules(appModule, platformModule)
                        }
                    }
                    
                    //Android
                    class MainApplication : Application() {
                        override fun onCreate() {
                            super.onCreate()
                            initKoin()
                        }
                    }
                    
                    //iOS shared
                    @ObjCName("startKoinIos", exact = true)
                    fun startKoinIos() {
                        initKoin()
                    }
                    
                    //Swift AppDelegate.swift
                    import shared

                    func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]?) -> Bool {
                        SharedModuleKt.startKoinIos()
                        return true
                    }
                    """.trimIndent()
            )
        }
    }
}